var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc-content-root",class:_vm.contentClass,attrs:{"id":"skip-nav-target"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }